import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'article-category',
    cache: {
        ttl: 15000
    }
})
export class ArticleCategoryStore extends BaseStore {
    constructor() {
        super();
    }
}
